import { getAppConfig } from '@services/config';

const appConfig = getAppConfig();

export const PRISME_ST = 'mcommerce-ssr';

const prismeCommonConfig = {
    env: process.env.NODE_ENV,
    st: PRISME_ST,
    composant: 'app',
    version: appConfig.version,
    domaine: appConfig.domain,
    sendQueueTimeoutInMs: 2000,
    useAutoInstrumentation: true,
};

export const prismeFrontConfig = {
    ...prismeCommonConfig,
    clientUrlEndpoint: appConfig.prisme.url,
    applicationClientName: 'byou-front',
    applicationServerName: 'byou-back',
    authorizeUrls: appConfig.prisme.authorizeUrls,
    ignoreErrors: [
        'NEXT_REDIRECT',
        '_AutofillCallbackHandler',
        "Identifier 'b' has already been declared",
        'Identifier "b" has already been declared',
        'redeclaration of const b',
        "Can't create duplicate variable",
        'Piano SDK is loaded twice',
        'Minified React error #418',
        'Minified React error #299',
    ],
    ignoreErrorSources: ['piano.io', 'injectedScript'],
};

export const prismeBackConfig = {
    ...prismeCommonConfig,
    application: 'byou-back',
    ignoreUrls: [appConfig.assets.cms.url],
};
